// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Ticket2 } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = { Ticket2 };

// ==============================|| MENU ITEMS - category ||============================== //

const SuperAdminEmailTemplateNotification: NavItemType = {
    id: 'SuperAdminEmailTemplate',
    type: 'group',
    name: 'Super Admin Email Template Notification',
    icon: icons.Ticket2,
    children: [
        {
            icon: icons.Ticket2,
            id: 'SuperAdminEmailTemplateNotification',
            title: <FormattedMessage id="Email Template" />,
            type: 'item',
            url: '/superadmin/email-template'
        }
    ]
};

export default SuperAdminEmailTemplateNotification;
